export default "__VITE_ASSET__fc15d395__"